// extracted by mini-css-extract-plugin
module.exports = {"LowerSidedrawerOption":"LowerSidedrawerOption_LowerSidedrawerOption__IDtcj","Label":"LowerSidedrawerOption_Label__PbasR"};